import React,{useEffect, useState, useRef, useMemo} from 'react';
import './galleryVN.css';
import cross from'../../images/cross.png'
import stacyButtPetting from'../../images/stacyButtPetting.gif'
import stacyAfterOrgasm from'../../images/stacyAfterOrgasm.png'



function GalleryVN({goMenu, gallery, hzAdjuster}) {
  const [fullImg, setFullImg] = useState();
  const [fullImg2, setFullImg2] = useState();
  const [opac, setOpac] = useState(0);
  const wrap = useRef(null);
  const fullImgRef = useRef(null);
  const thisGallery = useRef([]);


useEffect(() => {
//navigator.app.overrideButton("backbutton", true);
//document.addEventListener("backbutton", goToMenu)

//return () => window.removeEventListener("backbutton", goToMenu);
});
  useEffect(() => {
    async function start(){
    await changeSetting(wrap,"current.style.opacity", 0, "", 0.02);
    wrap.current.style.zIndex = 0;
      }
      start();
},[]);

useMemo(() => {
  let chapterNum = 1; //Current chapter setter
  let actualNum = 0;
  let recordSlice;
for(let i =0;i<gallery.current.length;i++){
  if(gallery.current[i][1].includes("Chapter")){
    actualNum++;
    recordSlice = i;
    if(actualNum>chapterNum){
      break;
    }
  }
}
thisGallery.current= [...gallery.current];
if(actualNum>chapterNum){
thisGallery.current.splice(recordSlice);
}
},[]);

async function openImg(e){
  setFullImg(e.target.src);
  if(thisGallery.current[e.target.name] && thisGallery.current[e.target.name][3]){
    setFullImg2(thisGallery.current[e.target.name][3]);
  }
  await changeOnOff(false, setOpac);
  fullImgRef.current.onclick = closeImg;
}

async function closeImg(){
  await changeOnOff(true, setOpac);
  setFullImg(undefined);
  setFullImg2(undefined);
  fullImgRef.current.onclick = null;
}


  async function goToMenu(){
    wrap.current.style.zIndex = 15;
    await changeSetting(wrap,"current.style.opacity", 1, "", 0.02);
    goMenu();
  }

  /*function changeSetting(obj, setting, changeTo, um, speed, char){
    return new Promise((resolve, reject) => {
      const props = setting
          .split(/[./[\]]/g)
          .filter(p => p);
      const prop = props.pop();
      const parent = props.reduce((result, key) => result[key], obj);
      //
      var i;
      if(setting == "current.style.transform" || setting == "style.transform"){
        i = Math.round(parseFloat(parent[prop].split("(")[1].split(")")[0]));
      }else{
        i = Math.round(parseFloat(parent[prop]));
      }
      let slowDownTrigger = 0;
      let slower = 8;
      change();
    function change(){
      if(i>changeTo){
        i-=speed;
        if(i<changeTo){
          i = changeTo;
          if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
            parent[prop] = "scale("+i+")";
          }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
            parent[prop] = "rotateY("+i+"deg)";
          }else{
            parent[prop] = i+um;
          }
          resolve();
          return;
        }
    }else if(i<changeTo){
      i+=speed;
      if(i>changeTo){
        i = changeTo;
        if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
          parent[prop] = "scale("+i+")";
        }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
          parent[prop] = "rotateY("+i+"deg)";
        }else{
          parent[prop] = i+um;
        }
        resolve();
        return;
      }
    }else{
      if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
        parent[prop] = "scale("+i+")";
      }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
        parent[prop] = "rotateY("+i+"deg)";
      }else{
        parent[prop] = i+um;
      }
      resolve();
      return;
    }
    if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
      parent[prop] = "scale("+i+")";
    }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
      parent[prop] = "rotateY("+i+"deg)";
    }else{
      parent[prop] = i+um;
    }
  setTimeout(change, slower);
  return;
  }
  });
}*/

function changeSetting(obj, setting, changeTo, um, speed, char, float, stopLoading){
  speed=speed*2.3*hzAdjuster;
  return new Promise((resolve, reject) => {
    const props = setting
        .split(/[./[\]]/g)
        .filter(p => p);
    const prop = props.pop();
    const parent = props.reduce((result, key) => result[key], obj);
    var i;
    if(setting == "current.style.transform" || setting == "style.transform"){
      if(float){
        i = parseFloat(parent[prop].split("(")[1].split(")")[0]);
      }else{
        i = Math.round(parseFloat(parent[prop].split("(")[1].split(")")[0]));
      }
    }else if(setting == "current.style.filter" || setting == "style.filter"){
      if(float){
        i = parseFloat(parent[prop].split("(")[1].split("px)")[0]);
      }else{
        i = Math.round(parseFloat(parent[prop].split("(")[1].split("px)")[0]));
      }
    }else{
      if(float){
      i = parseFloat(parent[prop]);
      }else{
      i = Math.round(parseFloat(parent[prop]));
      }
    }
    let slowDownTrigger = 0;
    let slower = 8;
    change();
  function change(){
    if(i>changeTo){
      i-=speed;
      if(i<=changeTo){
        i = changeTo;
        if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
          parent[prop] = "scale("+i+")";
        }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
          parent[prop] = "rotateY("+i+"deg)";
        }else if((setting == "current.style.filter" || setting == "style.filter")){
          parent[prop] = "blur("+i+"px)";
        }else{
          parent[prop] = i+um;
        }
        resolve();
        return;
      }
  }else if(i<changeTo){
    i+=speed;
    if(i>=changeTo){
      i = changeTo;
      if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
        parent[prop] = "scale("+i+")";
      }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
        parent[prop] = "rotateY("+i+"deg)";
      }else if((setting == "current.style.filter" || setting == "style.filter")){
        parent[prop] = "blur("+i+"px)";
      }else{
        parent[prop] = i+um;
      }
      resolve();
      return;
    }
  }else{
    if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
      parent[prop] = "scale("+i+")";
    }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
      parent[prop] = "rotateY("+i+"deg)";
    }else if((setting == "current.style.filter" || setting == "style.filter")){
      parent[prop] = "blur("+i+"px)";
    }else{
      parent[prop] = i+um;
    }
    resolve();
    return;
  }
  if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
    parent[prop] = "scale("+i+")";
  }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
    parent[prop] = "rotateY("+i+"deg)";
  }else if((setting == "current.style.filter" || setting == "style.filter")){
    parent[prop] = "blur("+i+"px)";
  }else{
    parent[prop] = i+um;
  }
requestAnimationFrame(change);
return;
}
});
}

  function changeOnOff(toLow, setter){
    return new Promise((resolve, reject) => {
    if(toLow){
      var op=1;
      change(toLow);
    }else{
      var op=0;
      change();
    }
    function change(toLow){
    if(toLow){
      if(op>0){
        op-=0.03;
      setter(op);
      setTimeout(ChangetoLow, 5);
    }else{
      resolve();
      return;
    }
  }else{
    if(op<1){
      op+=0.018;
    setter(op);
    setTimeout(change, 5);
  }else{
    resolve();
    return;
  }
  }

  function ChangetoLow(){
     change(true);
  }
  }
  });
  }


return(
<div className='menu'>
{fullImg && <div className="fullScreen" style={{opacity:opac}}>
<img onClick={closeImg} src={cross} style={{cursor:"pointer"}}/>
<div ref={fullImgRef}><img src={fullImg}/><img src={fullImg2}/></div></div>
}
<div className="switchVN">
<div className="arrowBack" style={{position:"absolute",top:"-10px", left:"2vw"}} onClick={goToMenu}>
    <div></div>
</div>
<h2>Gallery</h2>
</div>
<div className='clickWrap' id='wrap' ref={wrap} style={{opacity:1,zIndex:15}}></div>
<div className="galleryBlurTopVN"></div>
<div className="galleryBlurBottomVN"></div>
<div className="galleryVN">
{thisGallery.current && thisGallery.current.map((item,index)=>{
  if(item[1] === "1"){
  return (
    <div className='image' onClick={openImg} style={{cursor:"pointer"}} key={index}>{item[0] && <img src={item[0]} name={index}/>} {item[3] && <img src={item[3]}/>}</div>
  )
}else if(item[1].includes('Chapter')){
    return (
<h2 style={{color:"#fff"}} key={index}>{item[1]}</h2>
);
}else{
  return (
    <div className='image' key={index}>{item[0] && <img src={item[0]} className='blur'/>} {item[3] && <img src={item[3]} className='blur'/>}</div>
  )
}
})}

<div className='image'><div><p>More scenes are already available on my</p><a href='https://www.patreon.com/c/almondraf' target="_blank"><div className="buttonPatreonGallery">PATREON</div></a></div><img src={stacyButtPetting} style={{position:"relative"}} className='blurT'/></div>
<div className='image'><div><p>More scenes are already available on my</p><a href='https://www.patreon.com/c/almondraf' target="_blank"><div className="buttonPatreonGallery">PATREON</div></a></div><img src={stacyAfterOrgasm} style={{position:"relative"}} className='blurT'/></div>

{/*<div className='image'><div><p>More scenes are already available on our</p><a href='https://www.patreon.com/nsfwjob' target="_blank"><div className="button">PATREON</div></a></div><img src={juliaBathTeasing} className='blurT'/></div>}
{<div className='image'><div><p>More scenes are already available on our</p><a href='https://www.patreon.com/nsfwjob' target="_blank"><div className="button">PATREON</div></a></div><img src={juliaSpankedAss} className='blurT'/></div>}
{<div className='image'><div><p>More scenes are already available on our</p><a href='https://www.patreon.com/nsfwjob' target="_blank"><div className="button">PATREON</div></a></div><img src={img80} className='blurT'/></div>}
{<div className='image'><div><p>More scenes are already available on our</p><a href='https://www.patreon.com/nsfwjob' target="_blank"><div className="button">PATREON</div></a></div><img src={img95} className='blurT'/></div>}
{<div className='image'><div><p>More scenes are already available on our</p><a href='https://www.patreon.com/nsfwjob' target="_blank"><div className="button">PATREON</div></a></div><img src={img91} className='blurT'/></div>}
*/}
</div>
</div>
);

}

export default GalleryVN;
